import type { RootState } from 'src/app/store/types';
import type { DispatchRead } from 'src/common/external/bambi-api/bambiApi';

/**
 * Single read choke point for the dispatch board. Returns the slice mirror
 * today; the planned cutover repoints just this selector at the RTK Query
 * cache, leaving consumers untouched.
 */
export const selectEffectiveDispatchResponse = (
  state: RootState
): DispatchRead | undefined => state.dispatcher.dispatchResponse;
